/**
 * Canonical decanato / participation group options.
 * Keep signup and admin filters in sync from this list only.
 */
const NUMBERED_DECANATOS = Array.from({ length: 14 }, (_, index) => String(index + 1));

const SPECIAL_DECANATOS = [
    'Servidores',
    'Equipo Evento',
    'Vida Consagrada',
    'Movimientos y Apostolados Juveniles e Instituciones Educativas',
    'Organizaciones Civiles y otras participaciones',
];

export const DECANATO_OPTIONS = [
    ...NUMBERED_DECANATOS,
    ...SPECIAL_DECANATOS,
];

export default DECANATO_OPTIONS;
